import React from "react";
import { twMerge } from "tailwind-merge";

export interface SurfaceProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "className"> {
  className?: string;
  bodyClassName?: string;
  children?: React.ReactNode;
}

export const Surface: React.FC<SurfaceProps> = ({
  className,
  bodyClassName,
  children,
  ...props
}) => (
  <div
    className={twMerge(
      "flex flex-col rounded-lg border border-gray-200 bg-white",
      className
    )}
    {...props}
  >
    <div
      className={twMerge(
        "flex h-full flex-col justify-center gap-4 p-6",
        bodyClassName
      )}
    >
      {children}
    </div>
  </div>
);

export default Surface;
